import { render, staticRenderFns } from "./Wysibb.vue?vue&type=template&id=07c849fc&"
import script from "./Wysibb.vue?vue&type=script&lang=js&"
export * from "./Wysibb.vue?vue&type=script&lang=js&"
import style0 from "./Wysibb.vue?vue&type=style&index=0&id=07c849fc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports